import store from '~store'

export const chat_room = class {
	static new_toast(toast) {
    store.dispatch('layouts/newToast', {
      variant: toast.alert_type,
      message: toast.message,
    })
  }
	static img_input_allowed_types = ['image/png', 'image/jpeg'];
	static error_img_path = '/images/icon_exclamation_404.svg';
	constructor(el, self) {
		this.el = $(el);
		this.display = false;
		this._set_self(self);
		this._toggle(false);
		this._init();
		return this;
	}
	open(student_id) {
		this.student_id = student_id;
    this._api_load();
    this._toggle(true);
  }
	close() {
		this.student_id = null;
    this._clear_all_msg();
    this._toggle(false);
  }
	_set_self({ name, token }) {
		this.self_name = name;
		this.self_token = token;
		return this;
	}
	_init() {
		this.msg_arr = [];
		this._create_main_window();
		this._create_img_view_window();
	}
	_toggle(target_display) {
		if (typeof target_display == 'boolean') this.display = target_display;
		else this.display = !this.display;
		this.el.css('display', this.display ? 'block' : 'none');
	}

	/* ======== 聊天室主要視窗 ======== */
	_create_main_window() {
		let main_block = $('<div class="chat_room_main_block">');

		$('<div class="top_bar">').html('問題回報').appendTo(main_block);
		$('<div class="close_btn">').on('click', () => this.close()).appendTo(main_block);
		this.msg_list = $('<div class="msg_list">').appendTo(main_block);
		this._create_enter_area().appendTo(main_block);

		this.el.append(main_block);
	}
	_create_enter_area() {
		let enter_area = $('<div class="enter_area">');

		let textarea_holder = $('<div class="textarea_holder">');

		/*文本區域*/
		this.textarea = $('<textarea placeholder="請輸入描述您的問題">')
			.on('input', () => this._textarea_height_update())
			.appendTo(textarea_holder);
		/*上傳圖片按鈕*/
		$('<button class="upload_img_btn">').on('click', this._upload_img).appendTo(textarea_holder);

		textarea_holder.appendTo(enter_area);

		/*送出按鈕*/
		$('<button class="send_msg_btn">').on('click', this._send_msg).appendTo(enter_area);

		return enter_area;
	}
	_textarea_height_update() {
		this.textarea.height('');
		this.textarea.height(Math.min(this.textarea[0].scrollHeight, 80));
	}

	/* ======== 聊天室圖片檢視視窗 ======== */
	_create_img_view_window() {
		this.img_view_window = $('<div class="chat_room_img_view_window">')
			.css('display', 'none')
			.on('click', (e) => {
				if ($(e.target).is('.close_btn') || e.target == this.img_view_window[0]) {
					this.img_view_window.css('display', 'none');
				}
			})
			.appendTo(this.el);

		$('<div class="close_btn">').appendTo(this.img_view_window);

		/*左右箭頭*/
		let left_arrow = $('<div class="left_arrow">').on('click', () => this._arrow_update_cur_view_img(-1));
		let right_arrow = $('<div class="right_arrow">').on('click', () => this._arrow_update_cur_view_img(1));


		/*中間圖片檢視*/
		this.cur_view_img = new Image();
		this.cur_view_img.onerror = () => {
			this.cur_view_img.src = chat_room.error_img_path;
		};

		let img_holder = $('<div class="img_holder">')
			.append(this.cur_view_img)
			.appendTo(this.img_view_window)
			.before(left_arrow)
			.after(right_arrow);

		this.img_list = $('<div class="img_list">');
		$('<div class="img_list_holder">')
			.append(this.img_list)
			.appendTo(this.img_view_window);
	}
	_open_img_view_window(target_data) {
		this._update_img_list(target_data);

		let target_img_data = this.img_arr.find(img_data => img_data.msg_id == target_data.msg_id);
		this._update_cur_view_img(target_img_data);

		this.img_view_window.attr('style', null);
	}
	_update_img_list() {
		/*抓圖片arr*/
		this.img_arr = this.msg_arr
			.filter(msg_data => msg_data.type == 'img')
			.map(msg_data => {
				return {
					msg_id: msg_data.msg_id,
					content: msg_data.content,
				};
			});

		/*載入圖片*/
		let loaded_img_arr = [];
		let loaded_count = 0;
		this.img_arr.forEach((img_data, index) => {
			let img = new Image();
			img.onload = () => {
				loaded_img_arr[index] = { img_data: img_data, loaded_img: img };
				if (++loaded_count == this.img_arr.length) this._append_canvas_to_list(loaded_img_arr);
			};
			img.onerror = () => {
				loaded_img_arr[index] = { img_data: img_data };
				if (++loaded_count == this.img_arr.length) this._append_canvas_to_list(loaded_img_arr);
			};
			img.src = img_data.content;
		});
	}
	_append_canvas_to_list = (loaded_img_arr) => {
		this.img_list.empty();
		loaded_img_arr.forEach(data => {
			if (!data.loaded_img) {
				$('<img>')
					.attr('src', chat_room.error_img_path)
					.on('click', () => this._update_cur_view_img(data.img_data))
					.appendTo(this.img_list);
				return;
			}

			let canvas = $('<canvas>').attr({
				width: data.loaded_img.width,
				height: data.loaded_img.height,
			}).on('click', () => this._update_cur_view_img(data.img_data))
				.appendTo(this.img_list);
			let ctx = canvas[0].getContext('2d');
			ctx.drawImage(data.loaded_img, 0, 0);
		});
		this._img_list_scroll();
	}
	_arrow_update_cur_view_img(direction) {
		let index = this.img_arr.indexOf(this.cur_view_img_data);
		index += direction;
		if (index < 0 || index == this.img_arr.length) return;
		this._update_cur_view_img(this.img_arr[index]);
	}
	_update_cur_view_img(img_data) {
		this.cur_view_img_data = img_data;

		/*中間圖片檢視*/
		this.cur_view_img.src = this.cur_view_img_data.content;

		let index = this.img_arr.indexOf(img_data);
		this.img_view_window.find('.left_arrow').toggleClass('hidden', index == 0);
		this.img_view_window.find('.right_arrow').toggleClass('hidden', index == this.img_arr.length - 1);

		this._img_list_scroll();
	}
	_img_list_scroll() {
		let index = this.img_arr.indexOf(this.cur_view_img_data);
		let target_img = this.img_list.children().eq(index);
		if (!target_img[0]) return;
		this.img_list.find('.active').removeClass('active');
		target_img.addClass('active');
		let scrollLeft = target_img[0].offsetLeft - this.img_list.width() / 2 + 50;
		this.img_list.animate({ scrollLeft: scrollLeft });
	}

	/* ======== 訊息顯示 ======== */
	_clear_all_msg() {
    this.msg_list.empty();
    this.msg_arr = [];
	}
	_update_all_msg(msg_arr) {
		msg_arr.forEach(msg_data => this._push_msg(msg_data));
    this._scroll_bottom();
	}
  _scroll_bottom() {
    this.msg_list.animate({
      scrollTop: this.msg_list.prop('scrollHeight')
    }, 1000);
  }
	_push_msg(msg_data) {
		this.msg_arr.push(msg_data);
		this._create_msg(msg_data);
	}
	_create_msg(msg_data) {
		if (msg_data.date != this.view_last_msg_date) {
			$('<div class="date">').html(msg_data.date).appendTo(this.msg_list);
			this.view_last_msg_date = msg_data.date;
		}

		let msg = $('<div class="msg">');

		/*名字*/
		if (msg_data.user_name == this.self_name) msg.addClass('self');
		else $('<div class="name">').html(msg_data.user_name).appendTo(msg);

		/*內容*/
		let content = $('<div class="cnt">').appendTo(msg);
		switch (msg_data.type) {
			case 'text': content.html(msg_data.content.replace(/\n/g, '<br>')); break;
			case 'img': this._create_img_to_msg(msg_data, content); break;
		}

		/*時間*/
		$('<div class="time">').html(msg_data.time.replace(/:\d*$/, '')).appendTo(msg);

		msg.appendTo(this.msg_list);
	}

	/* ======== 訊息中的圖片 ======== */
	_create_img_to_msg(msg_data, content) {
		content.addClass('img');
		let img = new Image();
		img.onload = () => {
			let canvas = $('<canvas>').attr({
				width: img.width,
				height: img.height,
			})
				.on('click', () => this._open_img_view_window(msg_data))
				.appendTo(content);
			let ctx = canvas[0].getContext('2d');
			ctx.drawImage(img, 0, 0);
		};
		img.onerror = () => {
			$('<img>').attr('src', chat_room.error_img_path).appendTo(content);
		};
		img.src = msg_data.content;
	}

	/* ======== 送出訊息 ======== */
	_send_msg = () => {
		let content = this.textarea.val();
		if (!content.replace(/\s|\r|\n/g, '')) { alert('內容不能為空'); return; }
		this.textarea.val('');
    this._textarea_height_update();
		this._api_send('text', content);
	}

	/* ======== 上傳圖片 ======== */
	_upload_img = () => {
		$('<input type="file">').on('change', this._img_input_onchange).click();
	}
	_img_input_onchange = (e) => {
		if (typeof FileReader == 'undifined') {
			alert('使用的瀏覽器不支援FileReader');
			return;
		}
		let file = e.target.files[0];
		if (chat_room.img_input_allowed_types.indexOf(file.type) == -1) {
			alert("上傳的檔案不是png或jpeg");
			return;
		}
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => this._send_img(reader.result);
	}
	_send_img(img_base64) {
		this._api_send('img', img_base64);
	}

	/* ======== api ======== */
	_api_send(type, content) {
		let datetime = new Date();
		let date = datetime.toJSON().slice(0, 10).replace('T', ' '); //現在日期
		let time = datetime.toLocaleTimeString([], { hour12: false }); //現在時間

		let msg_data = {
			student_id: this.student_id,
			type,
			date,
			time,
			content,
		};
		$.ajax({
			type: 'POST',
			url: `/api/store/${this.student_id}`,
      headers: {
        Authorization: 'Bearer ' + this.self_token,
        Accept: 'application/json, text/plain, */*',
      },
			data: msg_data,
		}).done(res => {
			chat_room.new_toast(res);
      msg_data.user_name = this.self_name;
      this._push_msg(msg_data);
      this._scroll_bottom();
		});
	}
  _api_load() {
    this._clear_all_msg();
    $.get(`/api/chat/${this.student_id}`, res => this._update_all_msg(res));
  }
}